import Swiper from 'swiper'
import { Autoplay, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import './scss/pages/homepage.scss'

new Swiper('.header-swiper', {
  modules: [Autoplay, Pagination],
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  pagination: {
    el: '.header-pagination',
    clickable: true,
  },
})
